module.exports = __webpack_public_path__ + "static/media/cover.90bb3c7c.jpeg";